export default {
	data(){
		return {
			warningClass: function (items) { return items['info_egresos/anulado']==1 ? true : false},
			tableGBoptions: { 
				modals: [
					{
						modal: "Anular",
						icon: "x-circle",
						title: "Anular Registro",
						variant: 'danger',
						showFtn: function (value) {
							if(value['info_egresos/anulado']===0  && value['autorizar'].length===0){ return true} return false;
						},
					},
				]
			},

			tableGBSearch: ['info_egresos/documento','info_egresos/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento', sort: null, sortTable: 'info_egresos/documento'},
					tbody: { td: ['info_egresos/documento',]}
				},
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'info_egresos/name'},
					tbody: { td: ['info_egresos/name'],}
				},
				{
					thead: { th: 'Concepto', },
					tbody: { td: ['info_egresos/descripcion'],}
				},
				{
					thead: { th: 'Razón', },
					tbody: { td: ['datos_razon/name'],}
				},
				{
					thead: { th: 'Fecha', },
					tbody: { td: ['info_egresos/fecha'],}
				},
				{
					thead: { th: 'Valor', },
					tbody: { td: ['info_egresos/valor']}
				},
				{
					thead: { th: 'Registro', },
					tbody: { td: ['info_egresos/id'], link: '/api/pdf/egresos', show: {td: 'info_egresos/anulado', compare: 0, else: 'Anulado'}}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
				},
			],			
		
		}
	},
}